<script setup lang="ts">
defineEmits(['load-more-games']);

const props = defineProps({
  pagination: {
    type: Object,
    required: true,
  },
});

const calculateWidthStyle = computed(() => {
  return { width: `${(props.pagination.to * 100) / props.pagination.total}%` };
});
</script>

<template>
  <div
    v-if="pagination.total > 0"
    class="pagination"
  >
    <div class="w-[40%] lg:w-[16%] bg-texts/10 rounded-md h-1 mb-4">
      <div
        class="bg-primary h-1 rounded-md"
        :style="calculateWidthStyle"
      ></div>
    </div>
    <span class="text-texts text-xs mb-4">
      {{
        $t('components.search_bar.pagination_title', {
          valueFrom: pagination.to,
          valueTo: pagination.total,
        })
      }}
    </span>
    <button
      v-if="pagination.currentPage !== pagination.lastPage"
      class="btn-more"
      @click="$emit('load-more-games')"
    >
      <span>
        {{ $t('components.search_bar.load_more') }}
      </span>
    </button>
  </div>
</template>

<style scoped lang="scss">
.pagination {
  @apply w-full pt-10 mb-9 flex justify-center items-center flex-col font-extrabold xl:mb-14;
  .btn-more {
    @apply bg-game-button-bg/20 rounded-md px-4 py-2.5 text-xs text-primary outline-none;
    &:hover {
      @apply bg-game-button-bg/10;
    }
  }
}
</style>
